import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { UserReportSubscription } from '@app/shared/models/smart-report.model';

@Injectable()
export class UserReportSubscriptionsAdapter implements Adapter<Array<UserReportSubscription>> {
    adapt(data: any): Array<UserReportSubscription> {
        return (data.reports?.map((item: any) => {
            return {
                company: {
                    id: item.companyId || 0,
                    name: item.companyName || '',
                },
                reportType: {
                    id: item.reportTypeId || 0,
                    name: item.reportTypeName || '',
                },
                reportConfig: {
                    id: item.reportConfigId || 0,
                    name: item.reportConfigName || '',
                },
                notificationId: item.notificationId || 0,
                globalReportsEmail: item.globalReportsEmail || false,
                globalTypeEmail: item.globalTypeEmail || false,
                active: item.active || false,
            } as UserReportSubscription;
        }) || []) as UserReportSubscription[];
    }
}
